import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { LoginHistoryTab } from "@/components/usage/LoginHistoryTab";
import { ApiLogsTab } from "@/components/usage/ApiLogsTab";
import { PagePerfAnalysisTab } from "@/components/usage/PagePerfAnalysisTab";

export default function Usage() {
  const [searchParams] = useSearchParams();
  const apiKeyIdParam = searchParams.get("apiKeyId");
  const defaultTab = apiKeyIdParam ? "api-logs" : "login-history";

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-foreground">Usage</h1>
        <p className="text-muted-foreground mt-1">
          Monitor login activity and system usage
        </p>
      </div>

      <Tabs defaultValue={defaultTab} className="space-y-6">
        <TabsList className="w-full justify-start border-b border-border rounded-none bg-transparent h-auto p-0 mb-6">
          <TabsTrigger value="login-history" className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent px-4 py-3">Login History</TabsTrigger>
          <TabsTrigger value="api-logs" className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent px-4 py-3">API Logs</TabsTrigger>
          <TabsTrigger value="page-perf-analysis" className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent px-4 py-3">Page Performance</TabsTrigger>
        </TabsList>

        <TabsContent value="login-history">
          <LoginHistoryTab />
        </TabsContent>

        <TabsContent value="api-logs">
          <ApiLogsTab initialApiKeyId={apiKeyIdParam} />
        </TabsContent>

        <TabsContent value="page-perf-analysis">
          <PagePerfAnalysisTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
